import { Component, OnInit, ViewChild } from "@angular/core";
import * as $ from "jquery";
import { ProfilePayload, UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { NotificationService } from "../notification/notification.service";
import { Location } from "@angular/common";
import { TradingService } from "../services/trading.service";
import { environment } from "../../environments/environment";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { FormatSettings } from "@progress/kendo-angular-dateinputs";
import { StorageService } from "../services/storage.service";
import { TranslateService } from "@ngx-translate/core";
import { ColDef, GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridAngular } from "ag-grid-angular";
import * as XLSX from "xlsx";
import * as moment from "moment";

@Component({
  selector: "app-payout",
  templateUrl: "./payout.component.html",
  styleUrls: ["./payout.component.css"],
})
export class PayoutComponent implements OnInit {
  submit: boolean = false;
  countries: any[];
  phonecodelist: any[];
  request_id: string = "";
  oPayouts: any = [];
  payouts: any = [];
  oPayoutRows: any = [];
  payoutRows: any = [];
  filter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  rowsFilter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;
  rows_prev_disabled = true;
  rows_next_disabled = false;
  states: any;
  singlePayout = {
    _csrf: null,
    amount: "",
    payment_mode: "IMPS",
    beneficiary_ifsc: "",
    beneficiary_acc_number: "",
    beneficiary_name: "",
    remarks: "",
  };
  bulk_file: File = null;
  public columnDefs: ColDef[] = [
    { field: "createdAt", headerName: "Created At", sort: "desc" },
    { field: "status", headerName: "Sttus" },
    { field: "request_id", headerName: "Req ID" },
  ];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    enableCellChangeFlash: true,
  };
  public priceRowData: any[] = [];
  @ViewChild(AgGridAngular) agGrid: AgGridAngular;
  priceGridApi!: GridApi;

  antiphis = {
    antiphiscode: "",
    _csrf: "",
  };

  errorObj = {
    password: "",
  };
  previousRoute: string;
  verificationstr = "";
  diables: Boolean;
  dateList: any = [];
  fileToUpload: File = null;
  passwordstatus: any = "strong";
  nameMacher: any = false;
  imagepath = environment.imageapiendpoint;
  datemodel: NgbDateStruct;
  user_country: any = [];
  public today_date = new Date();
  public tyear = this.today_date.getFullYear() - 18;
  public tmonth = this.today_date.getMonth() + 1;
  public tday = this.today_date.getDate() + 1;
  public value: Date = new Date(this.tyear, this.tmonth, this.tday);
  public max: Date = new Date(this.tyear, this.tmonth, this.tday);

  public format: FormatSettings = {
    displayFormat: "dd/MM/yyyy",
    inputFormat: "dd/MM/yyyy",
  };

  public shownewPassword: boolean = false;
  public showcurrentPassword: boolean = false;
  public showconfirmPassword: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private tradeService: TradingService,
    private notifyService: NotificationService,
    private location: Location,
    private storageService: StorageService,
    public translate: TranslateService
  ) {}

  public data: any = [];
  public wallist: any = {};
  formData = new FormData();
  twofastatus = "Disabled";
  tfaobject = {
    _csrf: "",
    tfa_url: "",
    sixdig_code: "",
    tfa_codeencrypt: "",
    tfa_status: 0,
  };
  spacecheck = true;

  ngOnInit() {
    this.tradeService.startLoader();
    this.data = {};
    this.data.test = "test";
    this.csrf();
    this.getData();
    this.initialfunction();
    this.diables = true;
    this.tradeService.stopLoader();
  }

  initialfunction() {
    this.userService.getAntiPhisCode(this.antiphis._csrf).subscribe((data) => {
      var phiscode = data.result;
      this.antiphis.antiphiscode = phiscode.antiphiscode;
    });
  }
  handleFileInput(files) {
    this.fileToUpload = files.item(0);
  }
  csrf() {
    this.userService.csrf().subscribe(
      (response) => {
        this.antiphis._csrf = response._csrf;
        this.tfaobject._csrf = response._csrf;
        this.singlePayout._csrf = response._csrf;
      },
      (err) => {}
    );
  }
  getRowNodeId(data) {
    return data["request_id"];
  }
  onGridReady(params: GridReadyEvent) {
    console.log(params);
    this.priceGridApi = params.api;
    this.priceGridApi.sizeColumnsToFit();
    this.priceGridApi.setDomLayout("autoHeight");
  }
  sort_by(field, reverse, primer) {
    var key = primer
      ? function (x) {
          return primer(x[field]);
        }
      : function (x) {
          return x[field];
        };
    reverse = [-1, 1][+!!reverse];
    return function (a, b) {
      return (a = key(a)), (b = key(b)), reverse * (+(a > b) - +(b > a));
    };
  }
  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    } else {
      this.rowsFilter.page++;
      this.showRows();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    } else {
      if (this.rowsFilter.page > 1) {
        this.rowsFilter.page--;
        this.showRows();
      }
    }
  }

  goBack() {
    this.request_id = "";
    this.payoutRows = [];
  }

  reset() {
    this.payouts = [];
    this.payoutRows = [];
    this.filter.page = 1;
    this.request_id = "";
    this.rowsFilter.page = 1;
    this.getData();
  }

  getData() {
    this.userService.getPayouts().subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      }
    });
  }

  showRows(id: string = null) {
    console.log("showRows called with id:", id);
    if (id) {
      this.request_id = id;
    }
    this.rowsFilter.id = this.request_id;
    //this.rowsFilter._csrf = this.csrf;
    this.userService.getPayoutRows(this.rowsFilter).subscribe(
      (list: any) => {
        this.payoutRows = list;
        this.oPayoutRows = list;
      },
      (err) => {
        // this.notifSer.error("Error", "No payout rows found for this request.", {
        //   timeOut: 3000,
        //   showProgressBar: true,
        //   pauseOnHover: false,
        //   clickToClose: true,
        //   maxLength: 50,
        // });
        this.payoutRows = [];
      }
    );
  }

  clearError(field) {
    switch (field) {
      case "password":
        this.errorObj.password = "";
        break;
    }
  }

  back() {
    this.location.back();
  }

  saveAntiphisingcode() {
    if (this.antiphis.antiphiscode !== "") {
      if (/\s/.test(this.antiphis.antiphiscode)) {
        this.spacecheck = false;
      } else {
        this.userService
          .saveAntiPhisCode(this.antiphis, this.storageService.getLanguage())
          .subscribe(
            (response) => {
              if (response) {
                if (this.storageService.getLanguage() == "es") {
                  this.notifyService.showSuccess("", response.messagees);
                } else {
                  this.notifyService.showSuccess("", response.message);
                }
              }
            },
            (err) => {
              if (this.storageService.getLanguage() == "es") {
                this.notifyService.showError("", err.error.messagees);
              } else {
                this.notifyService.showError("", err.error.message);
              }
            }
          );
      }
    }
  }
  singlePayoutRequest() {
    if (
      !this.singlePayout.amount ||
      isNaN(Number(this.singlePayout.amount)) ||
      Number(this.singlePayout.amount) <= 0
    ) {
      this.notifyService.showError("", "Please enter a valid amount.");
      return;
    } else if (
      !this.singlePayout.beneficiary_ifsc ||
      this.singlePayout.beneficiary_ifsc.trim().length < 5
    ) {
      this.notifyService.showError("", "Please enter a valid IFSC code.");
      return;
    } else if (
      !this.singlePayout.beneficiary_acc_number ||
      this.singlePayout.beneficiary_acc_number.trim().length < 6
    ) {
      this.notifyService.showError("", "Please enter a valid account number.");
      return;
    } else if (
      !this.singlePayout.beneficiary_name ||
      this.singlePayout.beneficiary_name.trim().length < 2
    ) {
      this.notifyService.showError(
        "",
        "Please enter a valid beneficiary name."
      );
      return;
    } else if (
      !this.singlePayout.remarks ||
      !/^[a-zA-Z0-9]{1,10}$/.test(this.singlePayout.remarks)
    ) {
      this.notifyService.showError(
        "",
        "Remarks should be maximum 10 alphanumeric characters."
      );
      return;
    }
    this.userService.singlePayoutRequest(this.singlePayout).subscribe(
      (res) => {
        this.singlePayout = {
          _csrf: this.singlePayout._csrf,
          amount: "",
          payment_mode: "IMPS",
          beneficiary_ifsc: "",
          beneficiary_acc_number: "",
          beneficiary_name: "",
          remarks: "",
        };
        if (this.storageService.getLanguage() == "es") {
          this.notifyService.showSuccess("", res.messagees);
        } else {
          this.notifyService.showSuccess("", res.message);
        }
      },
      (err) => {
        if (this.storageService.getLanguage() == "es") {
          this.notifyService.showError("", err.error.messagees);
        } else {
          this.notifyService.showError("", err.error.message);
        }
      }
    );
  }
  handleBulkFileUpload(e: any) {
    console.log(e);
    e.preventDefault();
    const file = this.bulk_file;
    const reader = new FileReader();
    reader.onload = (evt: any) => {
      const data = evt.target.result;
      // Use xlsx library to parse the file
      // Make sure to install xlsx: npm install xlsx --save

      const workbook = XLSX.read(data, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      console.log(json);
      const csrf = this.singlePayout._csrf;
      // You can now send this JSON to your API
      this.userService.bulkPayoutRequest({ rows: json, _csrf: csrf }).subscribe(
        (res) => {
          if (this.storageService.getLanguage() == "es") {
            this.notifyService.showSuccess("", res.messagees);
          } else {
            this.notifyService.showSuccess("", res.message);
          }
          window.location.reload();
        },
        (err) => {
          if (this.storageService.getLanguage() == "es") {
            this.notifyService.showError("", err.error.messagees);
          } else {
            this.notifyService.showError("", err.error.message);
          }
        }
      );
    };
    reader.readAsBinaryString(file);

    // this.userService.bulkPayoutRequest(formData).subscribe(res => {
    //   if (res.status == 200) {
    //     if (this.storageService.getLanguage() == 'es') {
    //       this.notifyService.showSuccess("", res.messagees);
    //     } else {
    //       this.notifyService.showSuccess("", res.message);
    //     }
    //     window.location.reload();
    //   }
    // })
  }
  onBulkFileChange(event: any) {
    const file = event.target.files[0];
    console.log(file);
    this.bulk_file = file;
  }
}
